import React, { useState, Fragment } from "react";
import axios from "axios";
import { format } from "date-fns";
import moment from "moment";

const baseURL = import.meta.env.VITE_API_URL;

const ReportCash = () => {
  const [reportCash, setReportCash] = useState([]);
  const [tranDate, setTranDate] = useState(moment().format("YYYY-MM-DD"));
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState({});

  const businessCode = localStorage.getItem("businessCode");
  const businessName = localStorage.getItem("businessName");
  const branchCodes = localStorage.getItem("branchCodes");

  const clearData = () => {
    setReportCash([]);
  };
  const formatDate = (dateString) => {
    return format(new Date(dateString), "MM/dd/yyyy");
  };
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 2,
    }).format(amount);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setIsOpen(false);
      await handleReportCash();
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!tranDate) errors.tranDate = "Transaction Date is required";
    return errors;
  };
  const handleReportCash = async () => {
    setLoading(true);
    clearData();
    setCurrentPage(1);
    try {
      console.log(businessCode);
      const formattedTranDate = formatDate(tranDate);
      const response = await axios.get(
        `${baseURL}/get/reportCash?businessCode=${businessName}&branchCode=${branchCodes}&tranDate=${formattedTranDate}&Page=${currentPage}&PageSize=${pageSize}`
      );
      if (response.status === 204) {
        setReportCash([]);
      } else {
        setReportCash(response.data);
        const kodeCabangs = response.data.map((item) => item.KodeCabang);
        const initialIsOpen = {};
        kodeCabangs.forEach((kodeCabang) => {
          initialIsOpen[kodeCabang] = true;
        });
        setIsOpen(initialIsOpen);
        setIsDataFetched(true);
        setCurrentPage(1);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const handlePageSizeChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, reportCash.length);
  const currentData = reportCash.slice(startIndex, endIndex);
  const headers = [
    "Branch Code",
    "Branch Name",
    "COA Code",
    "COA Name",
    "Is Debit",
    "Saldo",
    "Transaction Date",
  ];

  return (
    <div className="min-h-screen bg-gray-100 pt-20 px-5">
      <div className="max-w-7xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">
          Report Cash
        </h2>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 sm:grid-cols-4 gap-6 mb-6"
        >
          <div>
            <label className="block mb-2 text-sm font-medium text-gray-700">
              Transaction Date
            </label>
            <input
              type="date"
              value={tranDate}
              onChange={(e) => setTranDate(e.target.value)}
              className="p-3 border w-full rounded-lg focus:outline-none focus:ring-2"
            />
            {errors.tranDate && (
              <p className="text-red-500 text-sm mt-1">{errors.tranDate}</p>
            )}
          </div>
          <div className="sm:col-span-4">
            <button
              type="submit"
              className="w-full p-3 text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:ring-2"
            >
              Generate Report
            </button>
          </div>
        </form>

        {loading && <p className="text-blue-600">Loading...</p>}
        {isDataFetched && (
          <div>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border border-gray-300 rounded-lg shadow-md overflow-hidden">
                <thead className="bg-gray-50 border-b-2 border-gray-200">
                  <tr>
                    {headers.map((header) => (
                      <th
                        key={header}
                        className="px-4 py-2 text-left text-sm font-semibold text-gray-600"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {Object.entries(
                    currentData.reduce((acc, item) => {
                      const kodeCabang = item["KodeCabang"];
                      if (!acc[kodeCabang]) {
                        acc[kodeCabang] = [];
                      }
                      acc[kodeCabang].push(item);
                      return acc;
                    }, {})
                  ).map(([kodeCabang, group]) => (
                    <Fragment key={kodeCabang}>
                      <tr className="bg-gray-100">
                        <th
                          colSpan={headers.length}
                          className="px-4 py-2 text-left text-sm font-semibold text-gray-600"
                        >
                          {kodeCabang}
                          <button
                            className="ml-2 text-gray-600 hover:text-gray-900"
                            onClick={() =>
                              setIsOpen({
                                ...isOpen,
                                [kodeCabang]: !isOpen[kodeCabang],
                              })
                            }
                          >
                            {isOpen[kodeCabang] ? <>&#9650;</> : <>&#9660;</>}
                          </button>
                        </th>
                      </tr>
                      {isOpen[kodeCabang] &&
                        group.map((item, index) => (
                          <tr
                            key={index}
                            className="hover:bg-gray-100 transition-colors"
                          >
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.KodeCabang}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.NamaCabang}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.COACode}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.COAName}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {item.IsDebit ? "Yes" : "No"}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatCurrency(item.Saldo)}
                            </td>
                            <td className="px-4 py-2 text-sm text-gray-700">
                              {formatDate(item.TranDate)}
                            </td>
                          </tr>
                        ))}
                    </Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="mt-6 flex justify-between items-center">
              <div className="flex items-center space-x-4">
                <label htmlFor="pageSize" className="text-gray-700">
                  Show:
                </label>
                <select
                  id="pageSize"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </div>
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Previous
                </button>
                <span>
                  Page {currentPage} of{" "}
                  {Math.ceil(reportCash.length / pageSize)}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage * pageSize >= reportCash.length}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportCash;
